import { CHISIAMO_TAB } from "../utilities/Constants";
import NavBar from "./NavBar";

const ChiSiamo = () => {
  return (
    <>
      <NavBar activeItem={CHISIAMO_TAB} />
      <div className="container mt-5">
        <h1 className="text-center mb-4">Chi siamo</h1>
        <div className="row mb-3">
          <div className="col-lg-8 offset-lg-2">
            <p>
              Benvenuti nella nostra pizzeria! Siamo un team appassionato di
              autentica pizza italiana. Da anni portiamo avanti la tradizione
              culinaria italiana, creando le migliori pizze utilizzando
              ingredienti freschi e di alta qualità.
            </p>
            <p>
              La nostra missione è offrire un'esperienza gastronomica unica ai
              nostri clienti. Ogni pizza è preparata con cura e cuocia a legna
              per garantire una crosta croccante e un gusto delizioso.
            </p>
            <p>
              Siamo orgogliosi di offrire una vasta selezione di pizze, dalle
              classiche margherita e marinara alle specialità stagionali e
              vegetariane. Oltre alle pizze, proponiamo anche deliziosi
              antipasti, insalate fresche e dessert irresistibili.
            </p>
            <p>
              Vi invitiamo a venire a trovarci e gustare le nostre
              prelibatezze italiane. Siamo certi che rimarrete soddisfatti
              della qualità e del gusto delle nostre pizze.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChiSiamo;